// Redux action types
export const SET = 'one-state-provider-athena/set';
export const REINIT = 'one-state-provider-athena/reinit';

